<template>
  <section class="lras mt-3">
    <div class="lras__list">
      <div class="border-bottom mb-4">
        <h4>Предлагаем указать информацию о текущей занятости</h4>
        <div class="row pb-4">
          <div class="form-group col col-md-8 required">
            <label class='control-label'>Место работы</label>
            <select2 placeholder="Не указано" class="select2" :options="workTypeList" v-model="item.workType"/>
            <div class="mt-2" v-if="item.workType == 1">
              <input type="text" class="form-control" v-model="item.workOrganization"
                     placeholder="Укажите наименование организации"/>
              <div class="invalid-msg" v-if="v$.item.workOrganization.$error">Поле обязательно для заполнения</div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-bottom mb-4">
        <h4>Предлагаем заполнить параметры для поиска работы</h4>

        <div class="row pb-4">
          <div class="form-group col col-md-4">
            <component-input
                label="Должность"
                v-model="item.position"/>
          </div>
          <div class="form-group col col-md-4">

              <component-input
                  label="Опыт работы (лет)" :maxLength="2"
                  v-model="item.workExperience"/>
              <div class="invalid-msg" v-if="v$.item.workExperience.$error">Введите число</div>
            </div>


        </div>

        <div class="row pb-4">
          <div class="form-group col col-md-4">
            <component-input
                label="Заработок от (руб.)" :maxLength="10"
                v-model="item.salaryFrom"/>
            <div class="invalid-msg" v-if="v$.item.salaryFrom.$error">Введите число</div>
          </div>
          <div class="form-group col col-md-4">
            <component-input
                label="Заработок до (руб.)" :maxLength="10"
                v-model="item.salaryTo"/>
            <div class="invalid-msg" v-if="v$.item.salaryTo.$error">Введите число</div>
          </div>

        </div>
        <div class="row pb-4">
          <div class="form-group col col-md-4">
            <label class="control-label">График работы</label>
            <select2 placeholder="Не указано" class="select2" :options="scheduleTypeList" v-model="item.scheduleTypeId"/>

          </div>

          <div class="form-group select2 col col-md-4">
            <label class="control-label">Тип занятости</label>
            <select2 placeholder="Не указано" class="select2" :options="employmentTypeList" v-model="item.employmentTypeId"/>
          </div>
        </div>
        <div class="row pb-4">
          <div class="form-group col col-md-8">
            <label class="control-label">Навыки и качества</label>
            <textarea v-model="item.skills" class="form-control"></textarea>
          </div>
        </div>

        <div class="row pb-4">
          <div class="form-group col col-md-4">
            <label class="control-label">Профессиональная область</label>
              <Select2
                  :settings="{multiple: true}"
                  :options="professionAreaList"
                  v-model="item.professionAreaIds"/>
          </div>
          <div class="form-group col col-md-4">
            <label class="control-label">Местоположение</label>
              <Select2
                  :settings="{multiple: true}"
                  :options="districtList"
                  v-model="item.districtIds"/>
          </div>

        </div>


        <div class="row pb-4">
          <div class="col col-md-4">
            <div class="form-group">
              <label class='control-label'>Резюме</label>
              <file-upload width="100%" :entity="item"
                           @deleteFile="removeFile"
                           prop-name="resumeFile"
                           @uploaded="fileUploaded"/>
            </div>
          </div>
        </div>

      </div>

      <div class="d-flex align-items-center">
        <button-component class="btn btn-primary" @click="save">Отправить</button-component>
        <button-component class="btn mx-2" kind="secondary" @click="cancel">Отмена</button-component>
      </div>
    </div>
  </section>
</template>
<script>

import API from '../api/vacancy'
import Utils from "@/common/utils";
import Constants from "@/common/constants";
import {requiredIf, numeric} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import ComponentInput from "@/common/components/ComponentInput";
import FileUpload from "@/common/components/FileUpload";
//import ButtonComponent from "@/common/components/ButtonComponent";
import Select2 from "@/common/ui/Select2";
import ButtonComponent from "../../../common/components/ButtonComponent";

export default {
  name: "SearchJob",

  components: {
    ButtonComponent,
    Select2,
    //ButtonComponent,
    ComponentInput,
    FileUpload
  },

  data() {
    return {
      item: {
        workType: 1,
        scheduleTypeId: 0,
        employmentTypeId: 0,
        districtIds: [],
        professionAreaIds: []
      },
      professionAreaList: [],
      districtList: [],
      employmentTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      scheduleTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      workTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
        {id: 1, text: "в организации", selected: false},
        {id: 2, text: "индивидуальный предприниматель", selected: false},
        {id: 3, text: "самозанятый", selected: false},
        {id: 4, text: "нет постоянного места работы", selected: false},
      ]
    }
  },
  created() {
    this.loadLists();
    this.loadItem();
  },
  mounted() {
    console.log(this.item)
  },
  methods: {

    loadLists() {
      Utils.loadSelectOptions("district", this.districtList);
      Utils.loadSelectOptions("professionArea", this.professionAreaList);
      Utils.loadSelectOptions("employmentType", this.employmentTypeList);
      Utils.loadSelectOptions("scheduleType", this.scheduleTypeList);
    },
    loadItem() {
      API.find().then((response) => {
        if (response.data) {
          this.item = response.data;

          var self = this;
          self.item.districtIds = [];
          if (self.item.vacancyApplicantDistricts) {
            self.item.vacancyApplicantDistricts.forEach(function (n) {
              self.item.districtIds.push(n.districtId);
            });
          }

          self.item.professionAreaIds = [];
          if (self.item.vacancyApplicantProfessionAreas) {
            self.item.vacancyApplicantProfessionAreas.forEach(function (n) {
              self.item.professionAreaIds.push(n.professionAreaId);
            });
          }
        }
      });
    },
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      var self = this;
      this.item.vacancyApplicantDistricts = [];
      if (this.item.districtIds) {
        this.item.districtIds.forEach(function (n) {
          self.item.vacancyApplicantDistricts.push({districtId: n});
        });
      }


      this.item.vacancyApplicantProfessionAreas = [];
      if (this.item.professionAreaIds) {
        this.item.professionAreaIds.forEach(function (n) {
          self.item.vacancyApplicantProfessionAreas.push({professionAreaId: n});
        });
      }

      if(this.item.scheduleTypeId == 0)
        this.item.scheduleTypeId = null;

      if(this.item.employmentTypeId == 0)
        this.item.employmentTypeId = null;

      API.save(this.item).then((response) => {
        const msg = 'Данные успешно отправлены в АИС РМЛ РАС.'
        Constants.alert.fire('Сохранение', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          this.$router.push({path: '/'});
        }
      });
    },
    cancel() {
      this.$router.push({path: '/'});
    },
    removeFile() {
      this.item.resumeFileId = null;
      this.item.resumeFile = null;
    },
    fileUploaded(e) {
      this.item.resumeFile = e.data;
      this.item.resumeFileId = e.data ? e.data.id : null;
    },
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        workOrganization: {
          required: requiredIf(function () {
            return this.item.workType == 1
          })
        },
        salaryFrom: {numeric},
        salaryTo: {numeric},
        workExperience: {numeric},
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 100% !important;

  }
  .select2-selection__rendered{
    line-height: 36px;
  }
  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;

  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px !important;

  }
}
.lras__list {
  margin-top: 2rem;
  max-width: 1312px;
  width: 100%;
  padding: 24px;
  content: "";
  height: 100%;
  min-height: 254px;
  overflow: auto;
  top: 50%;
  left: 50%;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  background-color: #fff;
}

.form-check.required .control-label:after {
  content: "*";
  color: red;
}

.form-group.required .control-label:after {
  content: "*";
  color: red;
}

.invalid-msg {
  color: red;
  font-size: 0.75rem;
}
</style>